/**
 * Light-theme background: a clean, high-contrast alternative to the dark galaxy
 * animation. Renders a soft, slowly-drifting gradient mesh built entirely from
 * CSS (no Three.js / canvas) so it is cheap on both desktop and mobile and
 * honours `prefers-reduced-motion` (handled in index.css).
 *
 * It sits behind all content (`-z-10`) and never intercepts pointer events.
 */
export function LightBackground() {
  return (
    <div
      aria-hidden="true"
      className="light-bg absolute inset-0 -z-10 w-full h-full overflow-hidden pointer-events-none"
    >
      <div className="light-bg__mesh light-bg__mesh--a" />
      <div className="light-bg__mesh light-bg__mesh--b" />
      <div className="light-bg__mesh light-bg__mesh--c" />
    </div>
  );
}
